const appConfig = {
    apiPrefix: 'https://sois-backend.onrender.com',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    baseURL: "https://sois-backend.onrender.com/assets/"
}

export default appConfig